module.exports = __webpack_public_path__ + "static/media/services.e1b490ce.jpg";